<template>
    <div class="container">
        <my-navbar ></my-navbar>
	    <my-navbarFooter ></my-navbarFooter>
        <div class="legend">
            <div>
        <s-button theme="is-success is-small" label="" icon="arrow-circle-right" @onclick="" /> Véhicules Rentrant<br/>
            </div>
            <div>
        <s-button theme="is-danger is-small" label="" icon="arrow-circle-left" @onclick="" /> Véhicules Sortant
            </div>
        </div>
        <v-calendar  
        	@update:from-page="pageChange"  
        	ref="calendar" :rows="1" 
        	:first-day-of-week="2" 
        	:attributes="attributes" 
        	
        	>
            	
            	<template slot="day-content" slot-scope="props">
                	<div 
                		v-if="props.day.inMonth" 
                		:class="getClass(props.day.date)"
                		v-on:click="openModalItemDate(props.day.date)" >
                    <div>
                        <span>{{ props.day.day }}</span>
                    </div>
                    <div v-if="props.attributesMap">
                        <!-- Should probably check if the event actually occurs on this date -->
                        <div  v-for="dayEvent in props.attributesMap.events.customData.events">
                            <p class="label">
                            	<s-button 
                            		v-if="dayEvent.rentreLe.length!=0" 
                            		theme="is-success is-small is-rounded" 
                            		icon="arrow-circle-right" 
                            		:label="dayEvent.rentreLe.length"
                            	></s-button><br/>
                            	<s-button 
                            		v-if="dayEvent.departLe.length!=0" 
                            		theme="is-danger is-small is-rounded" 
                            		icon="arrow-circle-left" 
                            		:label="dayEvent.departLe.length"
                            	></s-button>
                            	
                            </p>
                        </div>
                    </div>
                </div>
            </template>
        </v-calendar>

        <item-date ref="itemDate" :date="itemDate" :inouts="tabItem" :open="openIdemDate"    @close="openIdemDate=false"/>
    </div>
</template>

<script>
	import planning_api     from "@/firebase/planning_api"
	import ItemDate         from "@/views/planning/itemDate.vue"
    export default {
        name: 'EventCalendar',
        components:{
        	ItemDate
        },
        data() {
            return {
                ghettoUpdate: 0,
                screens: {
			    tablet: '576px',
			    laptop: '992px',
			    desktop: '1200px',
			  },
                attributes: [{
                    key: 'events',
                    dates: [],
                    customData: {
                        events: []
                    }
                }],
                tabDates: {},
                openIdemDate: false,
                itemDate: null,
                tabItem: {},
                YYYYMM :null
            }
        },
        mounted() {                
                var date = new Date();
                this.init(this.convertYYYYMM(date));
        },

        methods: {
            getClass(date) {
                 var dateCurrent = new Date();
                 if (this.$convertDateToString(dateCurrent) == this.$convertDateToString(date))
                    return "caseDateSelected"
                 else
                    if (dateCurrent > date)
                         return "caseDateBefore"
                    else
                        return "caseDate";
            },
            convertYYYYMM(date) {
                var month = date.getMonth() + 1;
                if (month < 10)
                    month = "0" + month;
                return date.getFullYear()+"-"+month;
            },
            init(YYYYMM) {
               
                this.tabDates = {};
                
                if (this.YYYYMM != YYYYMM) {
                   this.YYYYMM = YYYYMM;
                 
                    planning_api.api.getClientsByMonth(this.$store, YYYYMM, inouts=>{
                        this.tabDates= inouts;
                        for (var dateKey in inouts) {
                            this.addEvent(dateKey, inouts[dateKey].rentreLe, inouts[dateKey].departLe);
                        }
                        
                      })
                }
            }
            ,
        	formatDate(date) {
        		var date = new Date(date);
            	var month = date.getMonth() + 1;
            	var day = date.getDate();
            	if (month < 10)
            		month = "0" + month;
            	if (day < 10)
            		day = "0" + day;
            	return date.getFullYear()+"-"+month+"-"+day;
        	},
        	openModalItemDate(date) {
               
                //var dateFormat = this.formatDate(date);
                var dateFormat= Date.parse(date);
              
                if (typeof(this.tabDates[dateFormat]) != "undefined") {
                    this.itemDate = dateFormat;
                    this.tabItem = this.tabDates[this.itemDate];
                    // je charge la fenêtre
                    var finishRentreLe = false;
                    var finishDepartLe = false;
                    this.$refs["itemDate"].init(this.itemDate, this.tabItem, (indexRentreLe, indexDepartLe)=>{
                        // j'ouvre la fenêtre seulement si tout a été chargé
                        
                        if (this.tabItem.rentreLe.length == 0)
                            finishRentreLe = true;
                         if (this.tabItem.departLe.length == 0)
                            finishDepartLe = true;

                       if (!finishRentreLe && indexRentreLe==(this.tabItem.rentreLe.length-1))
                            finishRentreLe = true;
                       if (!finishDepartLe && indexDepartLe==(this.tabItem.departLe.length-1))
                             finishDepartLe = true;
                       if (finishRentreLe && finishDepartLe) {
                           this.openIdemDate = true;
                       }
                            
                    })
                }
                   
                
        	},
            pageChange(change) {
                var date = new Date (change.year + "-" + change.month + "-01");
                this.init(this.convertYYYYMM(date));
               
            },
            addEvent(date, rentreLe, departLe) {
                var attribute = {
                    key: 'events',
                    dates: [],
                    customData: {
                        events: []
                    }}
                attribute.dates.push(new Date(parseInt(date)));
                attribute.customData.events.push({
                    rentreLe: rentreLe,
                    departLe: departLe,
                    date: date
                });      
                
                this.attributes.push(attribute);
            }
        }
    }
</script>
<style scoped>
    
    .caseDate {
        width: 55px;
        min-height: 81px;
        border: thin solid rgb(207, 209, 211);;
        text-overflow: 'ellipsis';
        margin: 1px;
        font-weight: bolder;
        text-align: center;
    }
    .caseDateBefore {
        width: 55px;
        min-height: 81px;
        border: thin solid rgb(207, 209, 211);;
        text-overflow: 'ellipsis';
        margin: 1px;
        font-weight: bolder;
        background-color: rgb(207, 209, 211);
        color:rgb(127, 131, 134);
        text-align: center;
    }
    .caseDateSelected {
        width: 55px;
        min-height: 81px;
        border: thin solid green;
        background-color: rgb(186, 223, 186);
        text-overflow: 'ellipsis';
        margin: 1px;
        font-weight: bolder;
        color: green;
        text-align: center;
    }
     .caseDateSelected:hover {
       background-color: lightblue;
       border: thin solid green;
       cursor: pointer;
    }
    .caseDate:hover {
        background-color: lightblue;
        border: thin solid lightblue;
        cursor: pointer;
    }
    .label {
    	margin-top: 2px;
    	margin-right: 2px;
    	text-align: right;
    	padding-bottom: 2px;
    }
    .legend {
        margin: 5px;
        border: thin solid rgb(207, 209, 211);
        width: 200px;
        padding: 3px;
    }
    .legend div {
        margin: 5px;
        font-weight: bold;
    }
</style>